// module.exports because of setupProxy.js

const SERVICE_NAME = 'live-casino';
const DEFAULT_CHANNEL_BUFFER_SIZE = 50;
const DEFAULT_LANGUAGE = 'en';
const DEFAULT_LOCIZE_NAMESPACE = 'initial';
const DEFAULT_LOCIZE_VERSION = 'latest';
const TRANSLATION_FALLBACK_PATH = '/locales/{{lng}}/{{ns}}';
const TRANSLATION_LOAD_PATH = '/v1/translation/{{lng}}/{{ns}}';

const NAMESPACE_SEPARATOR = '::'; //  INFO: ':' is default and can be used as part of locize key
const KEY_SEPARATOR = false; // INFO: json flat is use;

module.exports = {
  SERVICE_NAME,
  DEFAULT_CHANNEL_BUFFER_SIZE,
  DEFAULT_LANGUAGE,
  DEFAULT_LOCIZE_NAMESPACE,
  DEFAULT_LOCIZE_VERSION,
  TRANSLATION_FALLBACK_PATH,
  TRANSLATION_LOAD_PATH,
  NAMESPACE_SEPARATOR,
  KEY_SEPARATOR,
};
